exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.cardx .card-body .elist:first-child{\r\n    padding-top: 0;\r\n}\r\n.cardx .card-body .elist:last-child{\r\n    border-bottom: 0;\r\n    padding-bottom: 0;\r\n}\r\n.elist {\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid #f8f8f8;\r\n}\r\n.elist img {\r\n    height: 50px;\r\n    width: 50px;\r\n    display: block;\r\n    border-radius: 4px;\r\n    border: 2px solid rgba(238, 238, 238, 0.4);\r\n}\r\n.elist h5 {\r\n    line-height: 1;\r\n    font-size: 14px;\r\n    text-transform: capitalize;\r\n}\r\n.elist p {\r\n    font-size: 14px;\r\n    color: #999;\r\n    font-style: italic;\r\n    line-height: 1;\r\n}\r\n.elist span {\r\n    font-size: 14px;\r\n    color: #999;\r\n    margin: 5px 0 0 0;\r\n    display: block;\r\n}\r\n.yellow-bg{\r\n    background-color: lavenderblush;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/hrms.component.css
// module id = ../../../../../src/app/hrms/hrms.component.css
// module chunks = main